import script from "./ContactForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactForm.vue?vue&type=script&setup=true&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=f1b3df78&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1b3df78"]])

export default __exports__